import ITheme from "@/interfaces/iTheme";
import backgroundImage from "@assets/themes/crossland/backgroundImageCrosslandTheme.svg";

export class CrosslandTheme implements ITheme
{
    static Id = 'crossland';
    id = CrosslandTheme.Id;

    name = 'Crossland';

    colors = {
                application: '#005C61',
                text: '#E0E0E0',
                confirm: '#FDB515',
                confirmText: '#000',
                secondary: '#62B4E4',

                // Challenge card colors
                solved: '#007176',
                unsolved: '#FDB515',
                unsolvedText: 'black',
                locked: '#DA2128',
                noMoreAttempts: '#DA2128',
                disabled: '#DA2128',
                disabledText: 'white',

                windowBackground: '#0009',
                windowText: '#FFF',
                windowBorder: '#FFFFFF1F',

                tag: '#62B4E4',
                activeTab: '#62B4E4',
                dialogText: '#303030',
                dialogSuccessText: '#4CAF50',
                dialogFailureText: '#F44336',
                dialogIcon: '#553A97',
                success: '#4CAF50',
                warning: '#FF9800',

                // Table
                tableHeaderActionButtons: 'white',
                tableHeaderSelectAllButtons: '#62B4E4',

                //settings and bulk select checkboxes 
                checkedFill: '#DA2128',
                settingsInputError: '#D63B3B',
                settingsInputErrorShadow: 'black',

                // focus indicators
                focusVisibleIndicator: '#DA2128',

                // the most common color from the background image with sufficient contrast
                backgroundImageColor: 'black',

                actionButtonBackground: 'black',
                actionButtonText: 'white',
             };
        
    fontFamily = "Inter";
    landingFontFamily = "Inter";
    backgroundImage = backgroundImage;
    isDark = true;
}
